import React from 'react';
import { Typography, Button, Modal } from '@douyinfe/semi-ui';
import { IconClose, IconTick } from '@douyinfe/semi-icons';

class ModalConfirm extends React.Component {
    constructor(props) {
        super(props);
    }

    render () {
        const { open, caption, text, onClose, link } = this.props;

        const handleYesClick = () => {
            if (link) {
                window.location.href=`${link}`;
            }
            onClose();
        };

        const handleNoClick = () => {
            onClose();
        };

        return (
            <Modal
                visible={open}
                onCancel={handleNoClick}
                maskClosable={false}
                className="custom-modal"
                size="small"
                header={<div className="custom-modal-header">{caption}</div>}
                footer={
                    link ? (
                        <div className="custom-modal-footer">
                            <Button icon={<IconTick />} className="button-custom" onClick={handleYesClick}>Yes</Button>
                            <Button icon={<IconClose />} className="button-custom" onClick={handleNoClick}>No</Button>
                        </div>
                    ) : (
                        <div className="custom-modal-footer">
                            <Button icon={<IconClose />} className="button-custom" onClick={handleNoClick}>Close</Button>
                        </div>
                    )
                }
            >
                <div className="custom-modal-body">
                    <Typography.Paragraph>
                        { link ? text : 'Link is invalid or has not been added yet.'}
                    </Typography.Paragraph>
                </div>
            </Modal>
        );
    }
}

export default ModalConfirm;